// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"b87333af","352":"ec056473","387":"36feaad2","593":"421f3711","931":"02c17d0c"}[chunkId] + ".css";
};